<template>
  <div>
    <div
      id="second-menu"
      class="second-menu-wrapper">
      <div
        class="second-menu-icon"
        @click="bakTop()">
        <img src="@/static/img/home/back_top.png">
      </div>
      <div
        class="second-menu-icon kefu-show"
        @mouseover="kefuShow()"
        @mouseleave="kefuHide()">
        <img src="@/static/img/home/kefu.png">
      </div>
      <div
        class="service-mouover"
        @mouseover="kefuShow()"
        @mouseleave="kefuHide()"/>
      <div
        id="service-popup"
        class="service-popup"
        @mouseover="kefuShow()"
        @mouseleave="kefuHide()">
        <div class="popup-title">
          <img src="@/static/img/home/service-popup/shop.png">
          购买咨询
        </div>
        <div class="buy-suggest">
          <div class="suggest-item">
            <span class="suggest-title">客服热线</span>
            <span
              class="suggest-text"
              style="margin-top: 10px;">
              4006-019-800
            </span>
            <span class="suggest-text">周一至周五</span>
            <span class="suggest-text">9:00-18:00</span>
          </div>
          <div class="suggest-item">
            <span class="suggest-title">扫码咨询</span>
            <img src="@/static/img/home/service-popup/qcode.jpg">
          </div>
        </div>
        <div class="divider"/>
        <div class="popup-title">
          <img src="@/static/img/home/service-popup/letter.png">
          供稿咨询
        </div>
        <div class="letter-wrapper">
          <div class="letter-item">
            <span>客服邮箱：</span>
            <a href="mailto:646896024@qq.com">646896024@qq.com</a>
          </div>
          <div class="letter-item">
            <span>供稿网址：</span>
            <a
              href="http://ftd.gty.gzxwtpw.com"
              target="_blank">http://ftd.gty.gzxwtpw.com
            </a>
          </div>
        </div>
        <div class="divider" />
        <div class="online-ask">
          <div class="popup-title">
            <img src="@/static/img/home/service-popup/chat.png">
            在线咨询
          </div>
          <button
            class="ask-button"
            @click="openAdvice">
            咨询
          </button>
        </div>
      </div>
      <div
        class="feedback-box"
        @click="feedbackShow()">
        <img src="@/static/img/home/gift.png">
        <span>体验反馈</span>
      </div>
    </div>
    <div
      id="feedback-wrapper"
      class="feedback-wrapper">
      <div class="feedback-title">
        <span>贵图云创意网站满意度反馈答卷</span>
        <img
          src="@/static/img/home/service-popup/close.png"
          @click="feedbackHide()">
      </div>
      <div class="feedback-content">
        <span class="content-title">你对贵图云网站的整体满意度如何？</span>
        <div class="feedback-list">
          <div
            class="rate-item rate-1"
            @mouseover="rateOver(0)"
            @mouseleave="rateLeave(0)">
            <img
              id="rate-1"
              src="@/static/img/home/service-popup/rating-emoji-1.png">
            <span>非常不满意</span>
          </div>
          <div
            class="rate-item rate-2"
            @mouseover="rateOver(1)"
            @mouseleave="rateLeave(1)">
            <img
              id="rate-2"
              src="@/static/img/home/service-popup/rating-emoji-2.png">
            <span>不满意</span>
          </div>
          <div
            class="rate-item rate-3"
            @mouseover="rateOver(2)"
            @mouseleave="rateLeave(2)">
            <img
              id="rate-3"
              src="@/static/img/home/service-popup/rating-emoji-3.png">
            <span>一般</span>
          </div>
          <div
            class="rate-item rate-4"
            @mouseover="rateOver(3)"
            @mouseleave="rateLeave(3)">
            <img
              id="rate-4"
              src="@/static/img/home/service-popup/rating-emoji-4.png">
            <span>满意</span>
          </div>
          <div
            class="rate-item rate-5"
            @mouseover="rateOver(4)"
            @mouseleave="rateLeave(4)">
            <img
              id="rate-5"
              src="@/static/img/home/service-popup/rating-emoji-5.png">
            <span>非常满意</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    elementId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$nextTick(() => {
      document.getElementById(this.elementId).addEventListener('scroll', this.secondMenuShow)
    })
  },
  // beforeDestroy () {
  //   document.getElementById(this.elementId).removeEventListener('scroll', this.secondMenuShow)
  // },
  methods: {
    secondMenuShow () {
      // 右侧导航栏弹出
      if (document.getElementById(this.elementId).scrollTop > document.body.clientHeight * 0.8) {
        document.getElementById('second-menu').style.transform = 'translateX(0px)'
      } else {
        document.getElementById('second-menu').style.transform = 'translateX(999px)'
      }
      this.$emit('set-scroll', document.getElementById(this.elementId).scrollTop)
    },
    feedbackShow () {
      document.getElementById('second-menu').style.display = 'none'
      document.getElementById('feedback-wrapper').style.display = 'block'
    },
    feedbackHide () {
      document.getElementById('second-menu').style.display = 'block'
      document.getElementById('feedback-wrapper').style.display = 'none'
    },
    bakTop () {
      document.getElementById(this.elementId).scrollTop = 0
    },
    kefuShow () {
      document.getElementById('service-popup').style.display = 'block'
    },
    kefuHide () {
      document.getElementById('service-popup').style.display = 'none'
    },
    rateOver (index) {
      let rateList = document.getElementsByClassName('rate-item')
      for (let i = 0; i < rateList.length; i++) {
        console.log(rateList[i])
        if (i === index) {
          document.getElementById('rate-' + (index + 1)).src = 'static/img/home/service-popup/rating-emoji-' + (index + 1) + '.gif'
        } else {
          document.getElementById('rate-' + (i + 1)).style.filter = 'grayscale(1)'
        }
      }
    },
    rateLeave () {
      let rateList = document.getElementsByClassName('rate-item')
      for (let i = 0; i < rateList.length; i++) {
        document.getElementById('rate-' + (i + 1)).src = 'static/img/home/service-popup/rating-emoji-' + (i + 1) + '.png'
        document.getElementById('rate-' + (i + 1)).style.filter = ''
      }
    },
    openAdvice () {
      window.open('https://work.weixin.qq.com/kfid/kfc51faf4b71eaae826', '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './styles/ToolBar.css'
</style>
